import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { DropdownItem, DropdownItemGroup, DropdownMenuStateless as DropdownMenu } from '@atlaskit/dropdown-menu';
import ChevronDownIcon from '@atlaskit/icon/glyph/chevron-down';
import EditorCloseIcon from '@atlaskit/icon/glyph/editor/close';
import { withAnalytics } from '@atlassian/mpac-analytics';
import { withFeatureFlags } from '@atlassian/mpac-ui';
import ImmutablePropTypes from '@atlassian/react-immutable-proptypes';
import Immutable from 'immutable';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import CommonPropTypes from "../../../../../../common/constants/proptypes/CommonPropTypes";
import { ANALYTICS_SUBJECT_ID_SIDEBAR_FACET, ANALYTICS_SUBJECT_ID_TOPBAR_FACET, EVENT_CHANNEL, EVENT_SOURCE, FacetCollapsedEvent, FacetExpandedEvent, OBJECT_TYPE_FILTER } from "../../../../../constants/analytics/events";
import AddonDiscoveryPropTypes from "../../../../../constants/proptypes/AddonDiscoveryPropTypes";
export class InternalFacetDropdownBase extends Component {
  constructor(...args) {
    super(...args);

    _defineProperty(this, "state", {
      isOpen: false
    });

    _defineProperty(this, "close", () => {
      this.setState({
        isOpen: false
      });
    });

    _defineProperty(this, "handleOpenChange", ({
      isOpen
    }) => {
      // Work around an issue in Atlaskit where onOpenChange handler
      // is called when pressing Esc even when closed: https://ecosystem.atlassian.net/browse/AK-5044
      if (this.state.isOpen === isOpen) {
        return;
      }

      this.props.fireAnalyticsEvent({
        eventType: isOpen ? FacetExpandedEvent : FacetCollapsedEvent,
        actionSubjectId: this.props.facetBar === 'side' ? ANALYTICS_SUBJECT_ID_SIDEBAR_FACET : ANALYTICS_SUBJECT_ID_TOPBAR_FACET,
        objectType: OBJECT_TYPE_FILTER,
        objectId: this.props.facetValue,
        source: EVENT_SOURCE,
        attributes: {
          currentPerspective: this.props.perspective
        }
      }, EVENT_CHANNEL);
      this.setState({
        isOpen
      });
    });

    _defineProperty(this, "handleItemActivated", selection => {
      if (this.props.closeOnItemSelected) {
        this.close();
      }

      this.props.onItemActivated(selection);
    });
  }

  renderDropDownItemGroups() {
    return Object.keys(this.props.items).map(group => /*#__PURE__*/React.createElement(DropdownItemGroup, {
      key: group,
      title: group.toUpperCase()
    }, this.props.items[group].map(item => /*#__PURE__*/React.createElement(DropdownItem, {
      key: item.facetValue,
      id: item.facetValue,
      isSelected: item.isChecked,
      onClick: () => this.handleItemActivated({
        item
      })
    }, item.content))));
  }

  render() {
    const iconAfter = this.props.hasSelectedItem ? /*#__PURE__*/React.createElement("span", {
      onClick: this.props.onRemoveClick
    }, /*#__PURE__*/React.createElement(EditorCloseIcon, {
      label: "Remove selected"
    })) : /*#__PURE__*/React.createElement(ChevronDownIcon, null);
    const shouldFitContainer = this.props.facetBar === 'side';
    const buttonProps = {
      component: 'div',
      appearance: 'subtle',
      isSelected: this.state.isOpen,
      shouldFitContainer,
      style: {
        textAlign: 'left'
      },
      iconAfter
    }; // MC-731 facet = categories && sortingLogicForCategory = usage-and-alphabetical
    // items = {popular: List of popular categories , all: List of all categories}

    if (!Immutable.List.isList(this.props.items)) {
      return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(DropdownMenu, {
        shouldFitContainer: shouldFitContainer,
        isOpen: this.state.isOpen,
        onOpenChange: this.handleOpenChange,
        shouldFlip: false,
        triggerType: "button",
        triggerButtonProps: buttonProps,
        trigger: this.props.label
      }, this.renderDropDownItemGroups()));
    } else return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(DropdownMenu, {
      shouldFitContainer: shouldFitContainer,
      isOpen: this.state.isOpen,
      items: [{
        items: this.props.items.toArray()
      }],
      onItemActivated: this.handleItemActivated,
      onOpenChange: this.handleOpenChange,
      shouldFlip: false,
      triggerType: "button",
      triggerButtonProps: buttonProps
    }, this.props.label));
  }

}

_defineProperty(InternalFacetDropdownBase, "propTypes", {
  facetBar: PropTypes.oneOf(['top', 'side']),
  closeOnItemSelected: PropTypes.bool,
  fireAnalyticsEvent: PropTypes.func.isRequired,
  filters: CommonPropTypes.filters.isRequired,
  facetValue: PropTypes.string.isRequired,
  hasSelectedItem: PropTypes.bool.isRequired,
  label: PropTypes.string.isRequired,
  items: PropTypes.oneOfType([ImmutablePropTypes.list, PropTypes.object]).isRequired,
  onItemActivated: PropTypes.func.isRequired,
  onRemoveClick: PropTypes.func.isRequired,
  perspective: AddonDiscoveryPropTypes.perspective.isRequired
});

export default withAnalytics(withFeatureFlags(InternalFacetDropdownBase));